import { api } from './api';

export type SystemSettingKey =
  | 'archive.edit.enabled'
  | 'archive.delete.enabled';

export type SystemFlagMap = Record<SystemSettingKey, boolean>;

class SystemSettingsService {
  async fetchAll(): Promise<SystemFlagMap> {
    const res = await api.get('/system-setting');
    return res.data?.data as SystemFlagMap;
  }

  async update(key: SystemSettingKey, value: boolean): Promise<void> {
    await api.put(`/system-setting/${key}`, { value });
  }
}

const systemSettingsService = new SystemSettingsService();
export default systemSettingsService;
